import React, { useState, useEffect } from "react";
import { Row, Col } from "reactstrap";

//Helpers
import { validarCampos } from "../../../../helpers/ValidadorDeCampos";

//Components
import TextField from "../../../../components/TextField";


export default function Codigo({
    tiposDeFiscalizcacao,
    solicitacaoFiscalizacao,
    loadTipoFiscalizacao,
    loadIntegracaoPesquisa,
    execucaoFiscalizacao,
    setExecucaoFiscalizacao,
    tipoFiscalizacao = null,
    camposCodigo = [],
    errors,
    setErrors
}) {
    //onChange para os campos de tipo de fiscalizacao e tipo de serviço
    const onChangeSearchable = (value, e) => {
        const _execucao = {
            ...execucaoFiscalizacao,
            [e.name]: value ? value.value.toString() : null,
        };

        const _campos = camposCodigo.filter(campo => campo.name === e.name);
        const fieldError = validarCampos(_execucao, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setExecucaoFiscalizacao(_execucao);

        if (e.name == "tipoFiscalizacao_Id" && value)
            loadTipoFiscalizacao(value.value);
    }
    //onChange para os campos de tipo de fiscalizacao e tipo de serviço
    const onChange = (e) => {
        const _execucao = {
            ...execucaoFiscalizacao,
            [e.target.name]: e.target.value,
        };

        const _campos = camposCodigo.filter(campo => campo.name === e.name);
        const fieldError = validarCampos(_execucao, _campos);

        const _errors = { ...errors };
        delete _errors[e.name];
        if (fieldError[1].length === 0)
            setErrors({ ..._errors });
        else
            setErrors({ ..._errors, ...fieldError[0] });

        setExecucaoFiscalizacao(_execucao);
    }
    return (
        <Row>
            {
                !solicitacaoFiscalizacao &&
                <>
                    <Col md="12" lg={tipoFiscalizacao ? "5" : "12"}>
                        <TextField
                            label={"* Tipo de fiscalização"}
                            name={"tipoFiscalizacao_Id"}
                            options={tiposDeFiscalizcacao.filter(value => value.permiteFiscalizacaoAvulsa)}
                            value={tiposDeFiscalizcacao.filter(value => value.value == execucaoFiscalizacao.tipoFiscalizacao_Id)}
                            onChange={onChangeSearchable}
                            type={"select"}
                            searchable
                            invalid={!!errors.tipoFiscalizacao_Id}
                        />
                    </Col>
                    {
                        tipoFiscalizacao &&
                        <Col md="12" lg={tipoFiscalizacao.integracoes.length > 0 ? 4 : 7}>
                            <TextField
                                label={"* Tipo de serviço"}
                                name={"tipoFiscalizacaoServico_Id"}
                                options={tipoFiscalizacao.tipoFiscalizacaoServicos.map(value => ({ value: value.id, label: value.identificacao }))}
                                value={
                                    tipoFiscalizacao.tipoFiscalizacaoServicos
                                        .map(value => ({ value: value.id.toString(), label: value.identificacao }))
                                        .filter(value => value.value == execucaoFiscalizacao.tipoFiscalizacaoServico_Id)
                                }
                                onChange={onChangeSearchable}
                                type={"select"}
                                searchable
                                invalid={!!errors.tipoFiscalizacaoServico_Id}
                            />
                        </Col>
                    }
                </>
            }
            {tipoFiscalizacao && 
            !!tipoFiscalizacao.integracoes &&
            tipoFiscalizacao.integracoes.length > 0 &&    
                <Col md="12" lg={!solicitacaoFiscalizacao ? "3" : "12"}>
                    <TextField
                        label={"* Código do item"}
                        name={"codigoItemFiscalizado"}
                        onChange={onChange}
                        value={execucaoFiscalizacao.codigoItemFiscalizado}
                        invalid={!!errors.codigoItemFiscalizado}
                    />
                </Col>
            }
        </Row>
    )
}